import { RootState } from '@/store/main';

export const getCategories = (state: RootState) => state.categories.categories;
export const getIsLoadingCategories = (state: RootState) => state.categories.loadingCategories;
export const selectAllProjectCategoriesForChannel = (state: RootState) =>
  state.categories.allProjectCategoriesForChannel;
export const selectIsLoadingAllProjectCategoriesForChannel = (state: RootState) =>
  state.categories.loadingAllProjectCategoriesForChannel;
